/**
 * @ngdoc directive
 * @name paybutton
 *
 * @description
 * Button to pay bill
 */
module.directive('paybutton', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            order: '='
        },
        controller: ["$scope", "$filter", "$timeout", "drupal", "moment", "$state", "$rootScope", "$cookies", "$window", function ($scope, $filter, $timeout, drupal, moment, $state, $rootScope, $cookies, $window) {
            $scope.loading = false;
            $scope.name = 'payForm_' + $scope.order.id;
            $scope.status = '';

            var amountMin = 0;
            var input = $scope.order.left;
            var total = $scope.order.left;
            if ($scope.order.stage === 'Panier') {
                total = 0;
                $scope.status = 'Panier';
            } else if ($scope.order.stage === 'Réservation') {
                $scope.status = 'Réservé';
                $scope.label = 'Payer';
                amountMin = $scope.order.deposit;
                input = $scope.order.deposit;
            } else if ($scope.order.stage === 'Commande') {
                if (total > 0) {
                    if ($scope.order.deposit > 0) {
                        $scope.status = 'Acompte versé';
                    } else {
                        $scope.status = 'A payer';
                    }
                } else {
                    $scope.status = 'Payée';
                }
            } else if ($scope.order.stage === 'Abandon') {
                $scope.status = 'Abandonnée';
                total = 0;
            } else {
                console.warn('un-handled case');
            }
            $scope.canPay = (total > 0);
            $scope.showPayForm = false;
            $scope.tooltip = 'Il reste ' + $filter('toCurrency')(total) + ' à régler';
            // TODO : create a credit card directive to avoid duplicate code
            $scope.order.card = {
                name: null,
                number: null,
                month: null,
                months: [],
                year: null,
                years: [],
                code: null
            };
            var value = null;
            var text = null;
            var months = moment.months();
            for (var m = 1; m <= 12; m++) {
                value = (m <= 9 ? '0' : '') + m;
                text = months[m - 1];
                $scope.order.card.months.push({ value: value, text: text });
            }
            var year = new Date().getFullYear();
            for (var y = 0; y <= 6; y++) {
                text = year + y;
                value = (text + '').substr(-2);
                $scope.order.card.years.push({ value: value, text: text });
            }
            $scope.bill = {
                amountMin: amountMin,
                amountMax: total,
                input: input
            };
            $scope.pay = function (val) {
                if (!$scope.loading) {
                    $scope.loading = true;
                    drupal.getRemoteMPIValues($scope.order, $scope.bill.input, 'paybutton', 1).then(function (response) {
                            $scope.order.mpi_values = response.mpiValues;
                            $scope.order.mpi_values.url_to_call = response.URLToCall;
                            $cookies.put('mpi_session', $scope.order.mpi_values.idSession);
                            $scope.order.mpi = undefined;
                            $scope.order.form = undefined;
                            $cookies.put('bill_input', $scope.bill.input);
                            $window.localStorage.setItem('order', angular.toJson($scope.order))
                            // update of the values of the form via scope isn't done before we submit the form. need to do it by hand
                            var $mpi_form = angular.element(document.querySelector('#mpi_form'))[0];
                            $mpi_form[0].value = $scope.order.mpi_values.idMerchant;
                            $mpi_form[1].value = $scope.order.mpi_values.idSession;
                            $mpi_form[2].value = $scope.order.mpi_values.amount;
                            $mpi_form[3].value = $scope.order.mpi_values.currency;
                            $mpi_form[4].value = $scope.order.mpi_values.CCNumber;
                            $mpi_form[5].value = $scope.order.mpi_values.CCExpDate;
                            $mpi_form[6].value = $scope.order.mpi_values.CVVCode;
                            $mpi_form[7].value = $scope.order.mpi_values.URLRetour;
                            $mpi_form[8].value = $scope.order.mpi_values.URLHttpDirect;
                            $mpi_form[9].value = $scope.order.mpi_values.email;
                            $mpi_form[10].value = $scope.order.mpi_values.firstName;
                            $mpi_form[11].value = $scope.order.mpi_values.lastName;
                            $mpi_form[12].value = $scope.order.mpi_values.address1;
                            $mpi_form[13].value = $scope.order.mpi_values.address2;
                            $mpi_form[14].value = $scope.order.mpi_values.zipCode;
                            $mpi_form[15].value = $scope.order.mpi_values.city;
                            $mpi_form[16].value = $scope.order.mpi_values.countryCode;
                            $mpi_form[17].value = $scope.order.mpi_values.totalQuantity;
                            $mpi_form.action = response.URLToCall;
                            $mpi_form.submit();
                    })
                }
            }
            $scope.togglePayForm = function () {
                $scope.showPayForm = !$scope.showPayForm;
            };
        }],
        template:
        '<div class="aqua-form--paybutton center-s" ng-class="{\'with-payform\': showPayForm}" ng-if="order.field_state !== \'paid\'">' +
        '  <div ng-if="loading" class="grid grid-middle">' +
        '    <div><icon type="loader" size="small"></icon></div>' +
        '    <div>' +
        '      <span class="aqua-form--paybutton--loading">{{ \'form.wait\' | translate }}...</span>' +
        '    </div>' +
        '  </div>' +

        '  <div ng-if="!loading" class="grid grid-middle grid-gutter-small">' +
        '      <span class="aqua-form--paybutton--status">{{ status }}</span>' +
        '        <div class="grid-4 is-hidden-s">' +
        '           <button title="{{ tooltip }}" ng-if="canPay && !showPayForm" class="aqua-form--button" ng-click="togglePayForm()">{{ label }}</button>' +
        '        </div>' +
        '  </div>' +

        '  <form novalidate name="payform" ng-submit="pay(this)" class="aqua-form--paybutton--payform grid grid-8 grid-12-s grid-gutter-small grid-middle" ng-show="showPayForm" ng-class="{\'is-pending\': loading}">' +
        '      <div class="aqua-form--field grid grid-v grid-12">' +
        '          <label class="aqua-form--label" for="card_number">{{ \'form.cardNumber\' | translate }}</label>' +
        '          <input id="card_number" name="number" class="aqua-form--input grid-12" ng-model="order.card.number" type="text" maxlength="16" ng-pattern="/^\\d{1,16}$/" required />' +
        '      </div>' +
        '      <div class="aqua-form--field grid grid-v grid-4">' +
        '          <label class="aqua-form--label" for="card_month">{{ \'form.cardMonth\' | translate }}</label>' +
        '          <select name="month" id="card_month" class="aqua-form--select grid-12" ng-model="order.card.month" required>' +
        '              <option ng-repeat="month in order.card.months" value="{{month.value}}" ng-selected="month.value == selected">{{month.text}}</option>' +
        '          </select>' +
        '      </div>' +
        '      <div class="aqua-form--field grid grid-v grid-4">' +
        '          <label class="aqua-form--label" for="card_year">{{ \'form.cardYear\' | translate }}</label>' +
        '          <select name="year" id="card_year" class="aqua-form--select grid-12" ng-model="order.card.year" required>' +
        '              <option ng-repeat="year in order.card.years" value="{{year.value}}" ng-selected="year.value == selected">{{year.text}}</option>' +
        '          </select>' +
        '      </div>' +
        '      <div class="aqua-form--field grid grid-v grid-4">' +
        '          <label class="aqua-form--label" for="card_code">{{ \'form.cardCode\' | translate }}</label>' +
        '          <input id="card_code" name="code" class="aqua-form--input grid-12" ng-model="order.card.code" type="text" maxlength="3" required />' +
        '      </div>' +
        '      <div class="grid grid-12 grid-gutter-small grid-middle">' +
        '        <label class="grid-3" for="formpay_input">Je règle :</label>' +
        '        <div class="grid-3">' +
        '           <input id="formpay_input" name="amount" class="aqua-form--input grid-12"  type="number" min="{{bill.amountMin}}" max="{{bill.amountMax}}" required ' +
        '               ng-model="bill.input" />' +
        '        </div>' +
        '        <span class="grid-2">€</span>' +
        '        <div class="grid-4">' +
        '           <button type="submit" ng-disabled="payform.$invalid" class="aqua-form--button grid-12">{{label}}</button>' +
        '        </div>' +
        '     </div>' +
        '   </form>' +
        '</div>'
    };
});
